import { motion } from "framer-motion";
import "./SideBarStyle.css";

const animVariants = {
  opened: {
    scale: 1,
  },
  closed: {
    scale: 0,
  },
};
const AddProjectComponent = ({
  open,
  onCancel,
  onAddProject,
  onProjectNameChange,
  isDark,
}) => {
  return (
    <>
      <div
        className="modal-wrapper"
        style={{ visibility: open ? "visible" : "hidden" }}
      >
        <motion.div
          variants={animVariants}
          initial={{ scale: 0 }}
          animate={open ? "opened" : "closed"}
          transition={{ type: "spring", damping: 20, stiffness: 260 }}
          className={`add-project-modal ${
            isDark ? "add-project-modal-dark" : ""
          }`}
          // className="add-project-modal"
        >
          <div>
            <h3>Add Project</h3>
            <div className="add-project-content">
              <input
                type="text"
                onChange={onProjectNameChange}
                placeholder="Enter the Project Name"
              />
              <button onClick={onAddProject}>Add</button>
              <button onClick={onCancel}>Cancel</button>
            </div>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default AddProjectComponent;
